import { UntypedFormGroup } from '@angular/forms';
import { BusinessEquipmentLabels } from '../business-equipment-labels/business-equipment-labels';

/**
 * Form object to used to instantiate a business equipment form component
 */
export class BusinessEquipmentFormObject {
  /**
   * @constructor
   */
  constructor(
    public labels: BusinessEquipmentLabels,
    public formGroup: UntypedFormGroup
  ) {}
}
